import React from 'react';
import { Plugin, CustomEditor } from '../types';

const HeadingPlugin: Plugin = {
  name: 'heading',
  
  commands: {
    insertHeading: (editor: CustomEditor, level: 1 | 2 | 3 | 4 | 5 | 6) => {
      // Create heading element
      const headingElement = {
        type: 'heading' as const,
        level,
        children: [{ text: `Heading ${level}` }]
      };
      
      // Insert heading at current selection
      const { insertNode } = editor;
      insertNode(headingElement);
    },

    insertParagraph: (editor: CustomEditor) => {
      // Create paragraph element
      const paragraphElement = {
        type: 'paragraph' as const,
        children: [{ text: 'New paragraph' }]
      };
      
      // Insert paragraph at current selection
      const { insertNode } = editor;
      insertNode(paragraphElement);
    },

    toggleHeading: (editor: CustomEditor, level: 1 | 2 | 3 | 4 | 5 | 6) => {
      // Toggle between heading and paragraph
      const { insertNode, deleteFragment } = editor;
      
      // Get current selection
      const { selection } = editor;
      if (!selection) return;

      // Check if current block is already a heading
      const [match] = Array.from(
        Array.from(editor.nodes({ at: selection, match: n => (n as any).type === 'heading' }))
      );

      if (match) {
        // If it's already a heading, convert to paragraph
        const paragraphElement = {
          type: 'paragraph' as const,
          children: [{ text: 'Converted to paragraph' }]
        };
        
        deleteFragment();
        insertNode(paragraphElement);
      } else {
        // Convert to heading
        const headingElement = {
          type: 'heading' as const,
          level,
          children: [{ text: `Heading ${level}` }]
        };
        
        deleteFragment();
        insertNode(headingElement);
      }
    }
  },

  renderElement: (props) => {
    const { attributes, children, element } = props;
    
    if (element.type === 'heading') {
      const level = (element as any).level || 1;
      const HeadingTag = `h${level}` as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
      
      return (
        <HeadingTag 
          {...attributes}
          style={{
            margin: '1em 0 0.5em 0',
            fontWeight: 600,
            lineHeight: 1.2,
            color: level <= 2 ? '#1f2937' : level <= 4 ? '#374151' : '#4b5563'
          }}
        >
          {children}
        </HeadingTag>
      );
    }
    
    if (element.type === 'paragraph') {
      return (
        <p 
          {...attributes}
          style={{
            margin: '0.5em 0',
            lineHeight: 1.6,
            color: '#374151'
          }}
        >
          {children}
        </p>
      );
    }
    
    return undefined;
  }
};

export default HeadingPlugin; 